import React from 'react'
import styled from 'styled-components'
import { CircleErrorIcon as CircleErrorIconBase } from '@chilecompra/react-kit/components'

export const CircleErrorIcon = styled(({ fontSize, ...props }) => <CircleErrorIconBase {...props} />)`
  &.MuiSvgIcon-root {
    font-size: ${props => props.fontSize};
  }
`
export const DialogWrapper = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px;
`
export const Row = styled('div')`
  margin: 16px 0 0;
  text-align: center;
  width: 100%;
`
